import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { apiActions as commonApiActions, apiResourceActionCreator } from "../../common";
import { authTokenSelector } from '../../session';
import { API_ENDPOINT } from './endpoints';

const actions = createActions({
  SYSTEM_STATUS: {
    PROFILE: undefined,
    API: {
      PROFILE: apiResourceActionCreator('profile')
    }
  }
})

export const apiAction = (authToken) => commonApiActions.authenticated.get(`${API_ENDPOINT}/profile`, authToken, actions.systemStatus.api.profile)

export function* getSystemProfile(action) {
  const authToken = yield select(authTokenSelector);
  yield put(apiAction(authToken));
}

const configuration = {
  name: 'profile',
  action: actions,
  sagas: getSystemProfile,
  reducers: {
    request: (state, action) => ({
      ...state,
      isFetching: true
    }),
    success: (state, action) => ({
      ...state,
      isFetching: false,
      profile: action.payload.profile,
      error: null
    }),
    failed: (state, action) => ({
      ...state,
      isFetching: false,
      isLoadingMore: false,
      error: action.payload.error
    }),
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/system-status/configurations/profile.js